'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import type React from 'react';
import { useState } from 'react';
import { usePreventBodyScroll } from '../hooks/usePreventBodyScroll';

interface ExpectedEarningsInfoSheetProps {
  children: React.ReactNode;
}

export const ExpectedEarningsInfoSheet = ({ children }: ExpectedEarningsInfoSheetProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // 바텀시트 열렸을 때 뒤쪽 스크롤 방지
  usePreventBodyScroll({ open: isOpen });

  return (
    <Sheet direction="bottom" defaultOpen={false} open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>{children}</SheetTrigger>
      <SheetPortal>
        <SheetContent>
          <SheetMotion direction="bottom">
            <BottomSheetTitle className="pb-2.5">
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer>
                <BottomSheetTitleBox>
                  <Typography variant="TextEtc16pxMed">예상 수익 안내</Typography>
                </BottomSheetTitleBox>
                <IconButton size="size28x28" onClick={() => setIsOpen(false)}>
                  <IcDelete />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>
            <ExpectedEarningsInfoSheetContent />
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};

const ExpectedEarningsInfoSheetContent = () => (
  <div className="flex flex-col px-4 bg-white safe-area-bottom">
    <div className="flex flex-col">
      <ul>
        <li className="flex gap-[4px] pb-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            예상 수익은 주문 건을 토대로 집계 되며 주문 확정까지 고객 변심 (주문 보류, 취소, 환불)이
            발생할 수 있으므로 확정 수익과 상이할 수 있습니다.
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            예상 수익은 일별 집계 내역이 업데이트 됩니다.
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            확정 수익은 활동하신 월의 익월 20일까지 구매 확정된 거래 건을 토대로 집계되는
            금액입니다.
          </Typography>
        </li>
      </ul>
    </div>
    <div className="py-3">
      <Typography variant="body14pxMed" className="pb-1">
        지급 수수료 안내
      </Typography>
      <div>
        <ul>
          <li className="flex gap-[4px] py-1">
            <Typography colorScheme="gray-600" variant="body13pxReg">
              •
            </Typography>
            <Typography colorScheme="gray-600" variant="body13pxReg">
              큐레이터 활동에 대한 지급 수수료는 아래 두 가지로 구분되어 지급됩니다.
            </Typography>
          </li>
          <li className="flex gap-[4px] py-1">
            <Typography colorScheme="gray-600" variant="body13pxReg">
              •
            </Typography>
            <div className="flex flex-col">
              <Typography colorScheme="gray-600" variant="body13pxReg">
                직접 기여 (수수료 10%)
              </Typography>
              <Typography colorScheme="gray-600" variant="body13pxReg">
                큐레이션 샵 전시 상품 혹은 상품 개별 제휴 링크와 동일한 상품을 구매할 시
              </Typography>
            </div>
          </li>
          <li className="flex gap-[4px] py-1">
            <Typography colorScheme="gray-600" variant="body13pxReg">
              •
            </Typography>
            <div className="flex flex-col">
              <Typography colorScheme="gray-600" variant="body13pxReg">
                간접 기여 (수수료 2%)
              </Typography>
              <Typography colorScheme="gray-600" variant="body13pxReg">
                큐레이션 샵 전시 상품 혹은 상품 개별 제휴 링크와 동일하지 않은 상품을 구매할 시
              </Typography>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
);
